(function () {
  var root = document.querySelector('[data-mbx-root]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('#mbx-data').textContent);
  var V = data.variants;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  function eur(c) { var v = c / 100; return v.toLocaleString('de-DE', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; }
  function isLeder(b) { return /^leder/i.test(b); }
  function label(b) { return b.replace(/^(Stoff|Leder)\s+/i, ''); }
  function find(b, f, q) { for (var i = 0; i < V.length; i++) { var v = V[i]; if (v.option1 === b && v.option2 === f && v.option3 === q) return v; } return null; }
  function isoWeek(d) { var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); var day = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - day); var y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1)); return Math.ceil(((t - y0) / 864e5 + 1) / 7); }

  var M = data.media || [];
  var gIdx = 0;
  function baseName(u) { return String(u || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, ''); }
  function mediaIndex(src) { var b = baseName(src); for (var i = 0; i < M.length; i++) { if (baseName(M[i].src) === b) return i; } return -1; }
  function show(i) {
    if (!M.length) return;
    gIdx = (i + M.length) % M.length;
    var img = $('#mbx-main-img'); if (!img) return;
    img.removeAttribute('srcset'); img.src = M[gIdx].src; img.alt = M[gIdx].alt || '';
    var th = $$('.mbx-thumb');
    th.forEach(function (x, k) { x.setAttribute('aria-current', k === gIdx ? 'true' : 'false'); });
    if (th[gIdx] && th[gIdx].parentNode.scrollWidth > th[gIdx].parentNode.clientWidth) { var p = th[gIdx].parentNode; p.scrollTo({ left: th[gIdx].offsetLeft - p.clientWidth / 2 + th[gIdx].offsetWidth / 2, behavior: 'smooth' }); }
    var c = $('#mbx-count'); if (c) c.textContent = (gIdx + 1) + ' / ' + M.length;
  }

  var bezuege = [];
  V.forEach(function (v) { if (bezuege.indexOf(v.option1) < 0) bezuege.push(v.option1); });
  var cur = V.filter(function (v) { return v.id === data.current; })[0] || V[0];
  var state = { b: cur.option1, f: cur.option2, q: cur.option3 };

  ['stoff', 'leder'].forEach(function (m) {
    var min = Infinity;
    V.forEach(function (v) { if (isLeder(v.option1) === (m === 'leder') && v.option2 === 'Verchromt') { var per = v.option3 === '4er-Set' ? v.price / 4 : v.price; if (per < min) min = per; } });
    var el = root.querySelector('[data-from="' + m + '"]'); if (el && min < Infinity) el.textContent = 'ab ' + eur(min) + ' je Stuhl';
  });

  var now = new Date();
  var kw = 'in KW ' + isoWeek(new Date(now.getTime() + data.weeksMin * 7 * 864e5)) + '–' + isoWeek(new Date(now.getTime() + data.weeksMax * 7 * 864e5));
  $$('.mbx-kw').forEach(function (el) { el.textContent = kw; });

  function renderSwatches() {
    var leder = isLeder(state.b);
    var list = bezuege.filter(function (b) { return isLeder(b) === leder; });
    var box = $('#mbx-swatches'); box.innerHTML = '';
    list.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'mbx-sw'; btn.setAttribute('aria-pressed', b === state.b ? 'true' : 'false');
      var src = data.swatches[b];
      btn.innerHTML = (src ? '<img loading="lazy" alt="" src="' + src + '">' : '<span class="mbx-sw__ph"></span>') + '<span class="mbx-sw__l"></span>';
      btn.title = label(b); btn.setAttribute('aria-label', label(b));
      btn.lastChild.textContent = label(b);
      btn.addEventListener('click', function () { state.b = b; update(); });
      box.appendChild(btn);
    });
    $('#mbx-colorcount').textContent = list.length + (leder ? ' Lederoptionen' : ' Stoffe');
    swUi(list.length + (leder ? ' Lederoptionen' : ' Stoffe'));
  }

  var swTouched = false;
  function swUi(txt) {
    var box = $('#mbx-swatches'); if (!box) return;
    var wrap = box.parentNode;
    if (!wrap.classList.contains('mbx-swwrap')) {
      wrap = document.createElement('div'); wrap.className = 'mbx-swwrap';
      box.parentNode.insertBefore(wrap, box); wrap.appendChild(box);
      var mk = function (dir) {
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'mbx-swnav mbx-swnav--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', dir < 0 ? 'Vorherige Farben' : 'Weitere Farben');
        b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function () { swTouched = true; box.scrollBy({ left: dir * box.clientWidth * 0.75, behavior: 'smooth' }); });
        wrap.appendChild(b);
      };
      mk(-1); mk(1);
      var hint = document.createElement('div'); hint.className = 'mbx-swhint'; hint.id = 'mbx-swhint';
      wrap.parentNode.insertBefore(hint, wrap.nextSibling);
      box.addEventListener('scroll', function () { if (box.scrollLeft > 8) swTouched = true; swState(); }, { passive: true });
      window.addEventListener('resize', swState);
    }
    var h = $('#mbx-swhint');
    if (h) h.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M15 8l4 4-4 4"/></svg><span>Zur Seite wischen für alle ' + txt + '</span>';
    swState();
  }
  function swState() {
    var box = $('#mbx-swatches'); if (!box || !box.parentNode.classList.contains('mbx-swwrap')) return;
    var wrap = box.parentNode, over = box.scrollWidth > box.clientWidth + 4;
    var atStart = box.scrollLeft < 8, atEnd = box.scrollLeft + box.clientWidth >= box.scrollWidth - 8;
    wrap.classList.toggle('is-over', over);
    wrap.classList.toggle('at-start', atStart);
    wrap.classList.toggle('at-end', atEnd);
    var h = $('#mbx-swhint'); if (h) h.hidden = !over || swTouched;
  }

  function setSummary() {
    var sum = state.b + ' · Gestell ' + state.f.toLowerCase() + ' · ' + state.q;
    var ain = $('#mbx-aponi-in');
    if (ain && !ain.disabled && ain.value.trim()) sum = sum.replace(state.b, state.b + ' (' + ain.value.trim() + ')');
    $('#mbx-summary').textContent = sum; var st = $('#mbx-sticky-sum'); if (st) st.textContent = sum;
  }

  function update() {
    var v = find(state.b, state.f, state.q) || cur;
    cur = v;
    var single = find(state.b, state.f, 'Einzelstuhl');
    var set = find(state.b, state.f, '4er-Set');
    var isSet = state.q === '4er-Set';
    $('#mbx-variant-id').value = v.id;
    $('#mbx-variant-id').dispatchEvent(new Event('change', { bubbles: true }));
    $$('.mbx-atc-price').forEach(function (el) { el.textContent = eur(v.price); });
    $('#mbx-price').textContent = eur(v.price);
    var showWas = isSet && v.compare_at_price && v.compare_at_price > v.price;
    $('#mbx-was').hidden = !showWas;
    if (showWas) $('#mbx-was-v').textContent = eur(v.compare_at_price);
    $('#mbx-perchair').hidden = !isSet;
    if (isSet) {
      $('#mbx-per').textContent = eur(v.price / 4);
      $('#mbx-save').textContent = showWas ? 'Sie sparen ' + eur(v.compare_at_price - v.price) : '';
    }
    if (single) $('#mbx-q1').textContent = eur(single.price);
    if (set) {
      $('#mbx-q4').textContent = eur(set.price / 4);
      $('#mbx-q4-total').textContent = '4 Stühle · ' + eur(set.price) + ' gesamt';
      $('#mbx-q4-save').textContent = set.compare_at_price > set.price ? eur(set.compare_at_price - set.price) + ' günstiger als einzeln' : '';
    }
    var chrom = find(state.b, 'Verchromt', state.q), black = find(state.b, 'Schwarz matt', state.q);
    if (chrom && black) { var diff = (black.price - chrom.price) / (state.q === '4er-Set' ? 4 : 1); $('#mbx-frame-extra').textContent = diff > 0 ? '+ ' + eur(diff) + ' je Stuhl' : 'ohne Aufpreis'; }
    $('#mbx-colorname').textContent = label(state.b);
    $('#mbx-wunsch').hidden = !/wunschfarbe/i.test(state.b);
    $$('[data-mat]').forEach(function (b) { b.setAttribute('aria-pressed', (b.dataset.mat === 'leder') === isLeder(state.b) ? 'true' : 'false'); });
    $$('[data-frame]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.frame === state.f ? 'true' : 'false'); });
    $$('[data-qty]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.qty === state.q ? 'true' : 'false'); });
    var ain = $('#mbx-aponi-in'); if (ain) ain.disabled = !/wunschfarbe/i.test(state.b);
    setSummary();
    var atc = $('#mbx-atc'); atc.disabled = !v.available;
    $('#mbx-atc-label').textContent = v.available ? 'In den Warenkorb' : 'Derzeit nicht bestellbar';
    var img = $('#mbx-main-img'), chip = $('#mbx-chip');
    var gi = v.featured_image ? mediaIndex(v.featured_image.src) : -1;
    if (gi > -1) show(gi);
    else if (img && v.featured_image) { img.removeAttribute('srcset'); img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400'; img.alt = v.featured_image.alt || ('Alyne ' + state.b); }
    chip.hidden = !!v.featured_image;
    chip.textContent = 'Beispielabbildung · Ihr Bezug: ' + label(state.b);
    renderSwatches();
    if (window.history && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
  }

  $$('[data-mat]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var leder = btn.dataset.mat === 'leder';
      if (isLeder(state.b) === leder) return;
      state.b = bezuege.filter(function (b) { return isLeder(b) === leder; })[0] || state.b;
      update();
    });
  });
  $$('[data-frame]').forEach(function (btn) { btn.addEventListener('click', function () { state.f = btn.dataset.frame; update(); }); });
  $$('[data-qty]').forEach(function (btn) { btn.addEventListener('click', function () { state.q = btn.dataset.qty; update(); }); });
  $$('.mbx-thumb').forEach(function (t, i) {
    t.addEventListener('click', function () { show(i); $('#mbx-chip').hidden = true; });
  });
  var main = $('.mbx-main');
  if (main && M.length > 1) {
    var arrow = function (dir) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mbx-nav mbx-nav--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Vorheriges Bild' : 'Nächstes Bild');
      b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', function () { show(gIdx + dir); $('#mbx-chip').hidden = true; });
      main.appendChild(b);
    };
    arrow(-1); arrow(1);
    var cnt = document.createElement('div'); cnt.className = 'mbx-count'; cnt.id = 'mbx-count'; main.appendChild(cnt); cnt.textContent = '1 / ' + M.length;
    var sx = 0, sy = 0, tracking = false;
    main.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tracking = true; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { show(gIdx + (dx < 0 ? 1 : -1)); $('#mbx-chip').hidden = true; }
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!main.contains(document.activeElement)) return;
      if (e.key === 'ArrowLeft') show(gIdx - 1); if (e.key === 'ArrowRight') show(gIdx + 1);
    });
  }

  var sticky = $('#mbx-sticky'), atcBtn = $('#mbx-atc');
  if ('IntersectionObserver' in window && sticky && atcBtn) {
    new IntersectionObserver(function (e) {
      var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelector('button').tabIndex = on ? 0 : -1;
    }).observe(atcBtn);
  }

  var wbox = $('#mbx-wunsch'), cards = data.aponiCards || [];
  if (wbox) {
    var w = document.createElement('div'); w.className = 'mbx-aponi';
    var html = '';
    if (cards.length) {
      html += '<div class="mbx-aponi__t">Aponi-Farbkarten <span>(antippen zum Vergrößern)</span></div><div class="mbx-aponi__cards">';
      cards.forEach(function (c, i) {
        html += '<button type="button" class="mbx-aponi__card" data-card="' + i + '"><img loading="lazy" alt="Aponi Farbkarte ' + (i + 1) + '" src="' + c.src + (c.src.indexOf('?') > -1 ? '&' : '?') + 'width=480"><span>' + c.label + '</span></button>';
      });
      html += '</div>';
    }
    html += '<label class="mbx-aponi__lab" for="mbx-aponi-in">Ihre Aponi-Farbe <span>(optional)</span></label>' +
      '<input class="mbx-aponi__in" id="mbx-aponi-in" type="text" name="properties[Aponi-Wunschfarbe]" form="mbx-product-form" maxlength="60" autocomplete="off" placeholder="z. B. 2720 schiefer" disabled>' +
      '<div class="mbx-aponi__help">Nummer und Name von der Farbkarte. Noch unsicher? Feld einfach leer lassen, wir beraten Sie nach der Bestellung.</div>';
    w.innerHTML = html;
    wbox.appendChild(w);
    var dlg = document.createElement('dialog'); dlg.className = 'mbx-lb';
    dlg.innerHTML = '<div class="mbx-lb__bar"><span id="mbx-lb-t"></span><button type="button" class="mbx-lb__x" aria-label="Schließen"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="mbx-lb__body"><img id="mbx-lb-img" alt=""></div><div class="mbx-lb__hint">Bild antippen zum Zoomen</div>';
    document.body.appendChild(dlg);
    var lbImg = dlg.querySelector('#mbx-lb-img');
    lbImg.addEventListener('click', function () { dlg.classList.toggle('is-zoom'); });
    dlg.querySelector('.mbx-lb__x').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    $$('.mbx-aponi__card').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = cards[+b.dataset.card];
        lbImg.src = c.src + (c.src.indexOf('?') > -1 ? '&' : '?') + 'width=1600'; lbImg.alt = 'Aponi Farbkarte: ' + c.label;
        dlg.querySelector('#mbx-lb-t').textContent = c.label;
        dlg.classList.remove('is-zoom');
        if (dlg.showModal) dlg.showModal(); else window.open(lbImg.src, '_blank');
      });
    });
    $('#mbx-aponi-in').addEventListener('input', function () { setSummary(); });
  }

  update();
})();
